import React, { type CSSProperties, type FC } from "react";
import classNames from "classnames";

import { useTheme } from "@app/styles/themes";
import { CardHeader } from "@shared/ui/card-header";

import "./ThemeSettings.scss";

interface ThemeSwatchStyle extends CSSProperties {
    "--theme-swatch-accent": string;
    "--theme-swatch-surface": string;
    "--theme-swatch-background": string;
}

/**
 * Временная страница выбора темы (позже переедет в настройки).
 */
export const ThemeSettings: FC = () => {
    const { themeId, themes, setThemeId } = useTheme();

    return (
        <div className="theme_settings_page">
            <CardHeader className="theme_settings_page__header" text="Тема оформления" />
            <div className="theme_settings_page__content">
                <p className="theme_settings_page__hint">Выбор применяется сразу и сохраняется на устройстве.</p>
                <ul className="theme_settings_page__list">
                    {themes.map((theme) => {
                        const selected = theme.id === themeId;
                        const swatchStyle: ThemeSwatchStyle = {
                            "--theme-swatch-accent": theme.tokens.color.accent.main,
                            "--theme-swatch-surface": theme.tokens.color.surface.base,
                            "--theme-swatch-background": theme.tokens.color.background.default,
                        };

                        return (
                            <li key={theme.id}>
                                <button
                                    type="button"
                                    className={classNames("theme_settings_page__option", {
                                        "theme_settings_page__option--selected": selected,
                                    })}
                                    aria-pressed={selected}
                                    onClick={() => setThemeId(theme.id)}
                                >
                                    <span className="theme_settings_page__swatches" aria-hidden="true" style={swatchStyle} />
                                    <span className="theme_settings_page__option-text">
                                        <span className="theme_settings_page__option-name">{theme.name}</span>
                                        <span className="theme_settings_page__option-meta">{theme.scheme}</span>
                                    </span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
            </div>
        </div>
    );
};
